import { API_ENDPOINTS } from '../config/api';
import { isCookieAuthActive, getAuthHeaders } from '../utils/auth';

const fetchWithAuth = async (url, options = {}) => {
  if (!isCookieAuthActive() && !localStorage.getItem('auth_token')) {
    console.error('❌ [Payments] Not authenticated - no cookie or token auth');
    throw new Error('Not authenticated');
  }
  
  console.log('📡 [Payments] Calling API:', url, '| Cookie auth:', isCookieAuthActive());
  
  const headers = getAuthHeaders(options.headers || {});
  
  const res = await fetch(url, { 
    ...options, 
    headers,
    credentials: 'include'
  });
  
  console.log('📥 [Payments] Response status:', res.status, '| URL:', url);
  
  if (!res.ok) {
    const text = await res.text();
    console.error('❌ [Payments] API error:', res.status, text);
    throw new Error(text || `Request failed with status ${res.status}`);
  }
  const data = await res.json();
  console.log('✅ [Payments] Success:', data);
  return data;
};

export const loadRazorpay = () => new Promise((resolve, reject) => {
  if (typeof window === 'undefined') {
    reject(new Error('Window is not available'));
    return;
  }
  if (window.Razorpay) {
    resolve(window.Razorpay);
    return;
  }
  const script = document.createElement('script');
  script.src = 'https://checkout.razorpay.com/v1/checkout.js';
  script.async = true;
  script.onload = () => resolve(window.Razorpay);
  script.onerror = () => reject(new Error('Failed to load Razorpay SDK'));
  document.body.appendChild(script);
});

export const getPaymentConfig = async () => fetchWithAuth(API_ENDPOINTS.PAYMENTS.CONFIG, { method: 'GET' });

export const createPaymentOrder = async (payload) => fetchWithAuth(API_ENDPOINTS.PAYMENTS.CREATE_ORDER, {
  method: 'POST',
  body: JSON.stringify(payload)
});

export const verifyPayment = async (payload) => fetchWithAuth(API_ENDPOINTS.PAYMENTS.VERIFY, {
  method: 'POST',
  body: JSON.stringify(payload)
});

export const reportPaymentFailure = async (payload) => fetchWithAuth(API_ENDPOINTS.PAYMENTS.FAILURE, {
  method: 'POST',
  body: JSON.stringify(payload)
});
